import React, { useEffect, useState } from 'react'
import { Box, Chip, Paper, Typography, makeStyles } from '@material-ui/core'
import StarIcon from '@material-ui/icons/Star'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import api from '../../api/client'
import { toFarsiDigits } from '../../assets/utils'

const useStyles = makeStyles((theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: 12,
    marginBottom: 16,
  },
  card: { borderRadius: 16, padding: '14px 16px', border: '1px solid #e6e9f6' },
  title: { fontWeight: 800, fontSize: 13.5, color: '#1a237e', marginBottom: 10, textAlign: 'right' },
  row: { display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8, alignItems: 'center' },
  chip: {
    fontSize: 11.5, fontWeight: 700, height: 26,
    '& .MuiChip-icon': { fontSize: 15 },
  },
  total: { fontSize: 11.5, color: '#607d8b', fontWeight: 700, marginInlineStart: 4 },
}))

const chipStyle = {
  ok: { background: '#e3f2fd', color: '#1565c0' },
  off: { background: '#f1f5f9', color: '#546e7a' },
  emp: { background: '#eceff1', color: '#455a64' },
  pct: { background: '#ede7f6', color: '#5e35b1' },
}

export default function BillingByOrgCards({ days = 365 }) {
  const classes = useStyles()
  const [rows, setRows] = useState([])

  useEffect(() => {
    api.get('users/admin/billing-by-org/', { params: { days } })
      .then((r) => setRows((r.data && r.data.rows) || []))
      .catch(() => setRows([]))
  }, [days])

  if (!rows.length) return null

  return (
    <Box className={classes.grid}>
      {rows.map((r) => {
        const off = Math.max(0, (r.total || 0) - (r.subscribed || 0))
        return (
          <Paper key={r.id} elevation={0} className={classes.card}>
            <Typography className={classes.title}>{toFarsiDigits(r.name)}</Typography>

            <Box className={classes.row}>
              <Chip size="small" icon={<CheckCircleIcon />} label={`مشترک ${toFarsiDigits(r.subscribed)}`}
                className={classes.chip} style={chipStyle.ok} />
              <Chip size="small" label={`غیرمشترک ${toFarsiDigits(off)}`}
                className={classes.chip} style={chipStyle.off} />
              <span className={classes.total}>کل: {toFarsiDigits(r.total)}</span>
            </Box>

            <Box className={classes.row} style={{ marginBottom: 0 }}>
              <Chip size="small" icon={<StarIcon />} label={`اشتراک ${toFarsiDigits(r.pct)}٪`}
                className={classes.chip} style={chipStyle.pct} />
            </Box>
          </Paper>
        )
      })}
    </Box>
  )
}
